import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useFormik } from 'formik';
import querystring from 'query-string';
import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Screens from '..';
import { SSOLoginTokenType } from '../../api/Constants';
import QueryParamsProxy from '../../utils/queryParamProxy';
import { initialValues, validationSchema } from './login-validations';
import { usePostLoginMutation, usePostSSOLoginMutation } from '../../state/query/login';
import { AUTH_TYPES } from '../../utils/authFlow/constants';
import { TEXT_KEY, getText } from '../../utils/localization';
import useNotification from '../../hooks/useNotification';

var useLogin = function useLogin(navigation) {
  var _useSelector = useSelector(function (state) {
    return state.callbackIntent;
  }),
      auth = _useSelector.auth;

  var _usePostLoginMutation = usePostLoginMutation(),
      _usePostLoginMutation2 = _slicedToArray(_usePostLoginMutation, 1),
      postLogin = _usePostLoginMutation2[0];

  var _usePostSSOLoginMutat = usePostSSOLoginMutation(),
      _usePostSSOLoginMutat2 = _slicedToArray(_usePostSSOLoginMutat, 1),
      postSSOLogin = _usePostSSOLoginMutat2[0];

  var _useNotification = useNotification(),
      addNotification = _useNotification.addNotification;

  var handleAuthentication = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var parameters, token;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (typeof document !== 'undefined') {
              parameters = querystring.parse(document.location.search.replace(/^.*\?/, ''));
              token = parameters.code || parameters.sso_token;

              if (token) {
                QueryParamsProxy.setQueryParams({
                  code: undefined,
                  sso_token: undefined
                });

                if (auth === AUTH_TYPES.LINK) {
                  QueryParamsProxy.navigate(navigation, Screens.LinkLoyaltyCard);
                  QueryParamsProxy.setQueryParams({
                    code: token
                  });
                } else {
                  postSSOLogin({
                    tokenValue: token.replace(/ /g, '+'),
                    tokenType: parameters.code ? SSOLoginTokenType.AUTH_CODE : SSOLoginTokenType.SSO_TOKEN
                  }).unwrap().catch(function (error) {
                    return addNotification({
                      message: error.data.message,
                      title: getText(TEXT_KEY.TRY_AGAIN),
                      button: getText(TEXT_KEY.OK)
                    });
                  });
                }
              }
            } // eslint-disable-next-line react-hooks/exhaustive-deps


          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []);
  useEffect(function () {
    handleAuthentication();
  }, [handleAuthentication]);

  var onSumbitHandler = function onSumbitHandler(_ref2) {
    var email = _ref2.email,
        password = _ref2.password;
    return postLogin({
      email: email,
      password: password,
      login_type: AUTH_TYPES.STANDARD
    }).unwrap().then(function (result) {
      return !result.success && formikValidation.setStatus(result.message);
    }).catch(function (error) {
      return error && formikValidation.setStatus(error.data.message);
    });
  };

  var formikValidation = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: onSumbitHandler,
    isInitialValid: false
  });

  var openForgotPassword = function openForgotPassword() {
    return QueryParamsProxy.navigate(navigation, Screens.ForgotPassword);
  };

  var closeModal = function closeModal() {
    return QueryParamsProxy.navigate(navigation, Screens.Start);
  };

  return {
    formikValidation: formikValidation,
    closeModal: closeModal,
    openForgotPassword: openForgotPassword
  };
};

export default useLogin;